import { render, staticRenderFns } from "./TopicoLink.vue?vue&type=template&id=4b7c0780"
import script from "./TopicoLink.vue?vue&type=script&lang=js"
export * from "./TopicoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports